<template>
<div class="main-feedback">
  <div v-if="!feedback.isSent" class="feedback-wrapper">
    <div class="bg-header">
      <div class="bg-header-cup">
        <img
          src="@/assets/images/cup.svg"
          alt="cup"
          class="fb-image-cup"
        />
      </div>
      <div class="fb-header-text">
        Поздравляем! Вы справились с заданием лучше чем {{ randomPercent }}% пользователей!
      </div>
    </div>

    <!-- Полезность -->
    <div class="fb-useful-question">
      <div class="fb-useful-question-text question-width">
        Кейс был полезным для Вас?
      </div>
      <div class="fb-checkbox-row">
        
        <div 
          @click="setFeedback('useful', true)"
          class="fb-checbox-container">

          <div class="fb-round-checkbox">
            <div 
            v-if="feedback.useful"
            class="fb-round-checkbox-checked"></div>
          </div>
          <div class="fb-checkbox-text">Да</div>
        </div>
        
        <div 
          @click="setFeedback('useful', false)"
          class="fb-checbox-container">
          
          <div class="fb-round-checkbox">
            <div
            v-if="!feedback.useful"
            class="fb-round-checkbox-checked"></div>
          </div>
          <div class="fb-checkbox-text">Нет</div>
        </div>

      </div>
    </div>

    <div
    v-if="feedback.useful"
    class="fb-thanks-info-text">
      Спасибо, скоро выложим новые сценарии, заходите проверить себя!
    </div>

    <div
    v-if="!feedback.useful"
    class="fb-not-useful-rows">

      <div class="fb-question-not-like">
        Поделитесь, что вам не понравилось?
      </div>

      <!-- Сложность -->
      <div class="fb-useful-question">
          
        <div class="fb-useful-question-text question-width">
          Сложность
        </div>

        <div class="fb-checkbox-row">
        
          <div 
          @click="setFeedback('complexity', 1)"
            class="fb-checbox-container">

            <div class="fb-round-checkbox">
              <div 
              v-if="feedback.complexity === 1"
              class="fb-round-checkbox-checked">
              </div>
            </div>
            
            <div class="fb-checkbox-text checkbox-text-width">Слишком сложно</div>
          </div>
        
          <div 
            @click="setFeedback('complexity', 2)"
            class="fb-checbox-container">
            
            <div class="fb-round-checkbox">
              <div
              v-if="feedback.complexity === 2"
              class="fb-round-checkbox-checked"></div>
            </div>
            <div class="fb-checkbox-text checkbox-text-width">Слишком просто</div>
          </div>

        </div>        
      </div>

      <!-- Частотность -->
      <div class="fb-useful-question">
          
          <div class="fb-useful-question-text question-width">
            Частотность
          </div>
  
          <div class="fb-checkbox-row">
          
            <div 
            @click="setFeedback('frequency' , 1)"
              class="fb-checbox-container">
  
              <div class="fb-round-checkbox">
                <div 
                v-if="feedback.frequency === 1"
                class="fb-round-checkbox-checked">
                </div>
              </div>
              
              <div class="fb-checkbox-text checkbox-text-width">Слишком редкая ситуация</div>
            </div>
          
            <div 
              @click="setFeedback('frequency' , 2)"
              class="fb-checbox-container">
              
              <div class="fb-round-checkbox">
                <div
                v-if="feedback.frequency === 2"
                class="fb-round-checkbox-checked"></div>
              </div>
              <div class="fb-checkbox-text checkbox-text-width">Слишком частая ситуация</div>
            </div>
  
          </div>        
      </div>

      <!-- Диагноз и лечение -->
      <div class="fb-useful-question">
          
          <div class="fb-useful-question-text question-width">
            Диагноз и лечение
          </div>
  
          <div class="fb-checkbox-row">
          
            <div 
              @click="setFeedback('disagreeDiagnosis' , !feedback.disagreeDiagnosis)"
              class="fb-checbox-container">
  
              <div class="fb-round-checkbox">
                <div 
                v-if="feedback.disagreeDiagnosis"
                class="fb-round-checkbox-checked">
                </div>
              </div>
              
              <div class="fb-checkbox-text checkbox-text-width">Не согласен с решением</div>
            </div>            
  
          </div>        
        </div>

    </div>

    <div class="fb-rate">
      <div class="fb-rate-text">
        Оцените сложность сценария:
      </div>
      
      <div class="fb-stars-and-text">
        <div class="fb-stars-text">
          <span>слишком просто</span>
          <span>слишком сложно</span>
        </div>

        <div class="fb-stars">
          <div
            v-for="(num, ind) of stars"
            :key="`st-${ind}`"
            class="cursor-pointer"
            @mouseover="starHover = num"
            @mouseleave="starHover = 0"
            @click="setFeedback('stars', num)"
          >
            <img
              v-if="feedback.stars < num"
              src="@/assets/images/star.svg"
              alt="star"
              class="fb-star"
            />
            <img
              v-if="feedback.stars >= num"
              src="@/assets/images/star_full.svg"
              alt="star"
              class="fb-star"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="fb-comment">
      <div class="fb-comment-text">
        Пожалуйста, оставьте ваш комментарий по данному сценарию:
      </div>
      <div class="fb-comment-field-wrapper">
        <textarea
          @change="setFeedback('comment', $event.target.value)"
          @focus="onResize"
          @blur="onResize"
          class="fb-textarea-field"
        ></textarea>
      </div>
    </div>

    <div class="fb-comment">
      <div class="fb-comment-text">
        Кейс на какую тему Вам было бы интересно потренировать
      </div>
      <div class="fb-comment-field-wrapper">
        <textarea
          @change="setFeedback('interestingCase', $event.target.value)"
          @focus="onResize"
          @blur="onResize"
          class="fb-textarea-field"
        ></textarea>
      </div>
    </div>

    <div class="fb-button-wrapper">
      <button
          class="fb-button"
          @click="sendFeedback"
        >
          Отправить
        </button>
    </div>

  </div>  

  <div v-if="feedback.isSent" class="bg-end-text-div">
    <span class="bg-end-text-span">
      Спасибо! 
      <p>Ваше мнение очень ценно для нас, мы обязательно учтем его при
      разработке следующих сценариев!</p>
    </span>
  </div>

</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapActions } from 'vuex'

export default {
    name: 'UserFeedback',
    data() {
        return {
            stars: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
            feedbackAnswers:{

            }
        }
    },
    computed: {
        ...mapGetters([
          "feedback"
        ]),
        randomPercent(){
            return (Math.random() * (85 - 70) + 70).toFixed(0)
        },

        convertFeedback(){
          const textFeedback = {
            "useful": "",
            "complexity": "",
            "frequency": "",
            "diagnosisAndTherapy": "",
            "rating": this.feedback.stars,
            "comment": this.feedback.comment,
            "interestingCase": this.feedback.interestingCase
          }
          
          if (this.feedback.useful) {
            textFeedback.useful = "Да"
          }
          else{
            textFeedback.useful = "Нет"
          }

          if (this.feedback.complexity === 1) {
            textFeedback.complexity = "Слишком сложно"
          }
          else if (this.feedback.complexity === 2) {
            textFeedback.complexity = "Слишком просто"
          }
          else {
            textFeedback.complexity = ""
          }

          if (this.feedback.frequency === 1) {
            textFeedback.frequency = "Слишком редкая ситуация"
          }
          else if (this.feedback.frequency === 2) {
            textFeedback.frequency = "Слишком частая ситуация"
          }
          else {
            textFeedback.frequency = ""
          }

          if (this.feedback.disagreeDiagnosis) {
            textFeedback.diagnosisAndTherapy = "Не согласен с решением"
          }
          else {
            textFeedback.diagnosisAndTherapy = ""
          }

          return textFeedback

        }

    },
    methods: {
        ...mapActions([
            'setFeedbackItem',
            "SEND_DATA_TO_API",
            "SEND_FEEDBACK_TO_API",
            'setWindowHeight',
        ]),
        setFeedback(name,value) {
            this.setFeedbackItem({"name": name, "value": value})
        },
        sendFeedback(){
          this.SEND_FEEDBACK_TO_API(            
            {
                "type": "feedback",
                // "feedback": this.feedback
                "feedback": this.convertFeedback
            }
          )          
          this.setFeedback('isSent', true)
        },
        onResize() {
          this.setWindowHeight(window.innerHeight)
        }
    }

}
</script>

<style>

</style>